import { ResetPasswordPage } from "@grafit/frontend-auth/reset-password-page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_no_auth/reset-password")({
  component: ResetPasswordPage,
});
